import { render, staticRenderFns } from "./UsersRolesManage.vue?vue&type=template&id=528b507e&"
import script from "./UsersRolesManage.vue?vue&type=script&lang=js&"
export * from "./UsersRolesManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports